<template>
  <div>
    <div class="container">
      <div class="find_wrap all">
        <div class="tab_area">
          <div id="" class="on">STEP 01. 전체 아이디 찾기</div>
          <div id="" class="">STEP 02. 전체 아이디 확인</div>
        </div>

        <div class="find_all_wrap">
          <div class="find_all_tab">
            <div id="find_phone" class="find_tab on" @click="toggleType('sms')">
              휴대폰 본인 확인 (문자)
            </div>
            <div id="find_email" class="find_tab" @click="toggleType('email')">
              이메일 주소 인증
            </div>
          </div>
          <div class="find_all_form find_all_form_phone">
            <h5>휴대폰 SMS 인증 코드 인증하기</h5>
            <form id="find_all" action="/check_otp" method="POST">
              <div class="input_group">
                <div class="title_area">
                  <p>휴대폰 번호</p>
                </div>
                <div class="input_area">
                  <input
                    id="find_all_phone"
                    v-model="hypenPhoneNum"
                    type="text"
                    class="input"
                    name="user_info"
                    placeholder="휴대폰 번호를 입력해 주세요."
                    maxlength="13"
                    @input="checkHP"
                  />
                  <div
                    id="code_send"
                    class="btn btn_basic"
                    :class="{ disabled: !isPhoneButtonEnabled }"
                    :disabled="!isPhoneButtonEnabled"
                    @click="sendOtp('sms')"
                  >
                    인증번호 받기
                  </div>
                </div>
              </div>

              <div class="input_group">
                <div class="title_area">
                  <p>인증코드 확인</p>
                </div>
                <div class="input_area">
                  <input
                    id="user_code"
                    v-model="userCode"
                    type="text"
                    class="input width_full"
                    name=""
                    placeholder="인증코드를 입력해 주세요."
                    maxlength="6"
                  />
                  <span id="code_count">--:--</span>
                </div>
                <div class="resend"></div>
              </div>

              <div class="btn_area">
                <input
                  type="button"
                  class="btn_orange"
                  value="확인"
                  @click="sendData()"
                />
              </div>
            </form>
          </div>

          <div class="find_all_form find_all_form_email">
            <h5>이메일 인증 코드 인증하기</h5>
            <form id="find_all" action="/check_otp" method="POST">
              <div class="input_group">
                <div class="title_area">
                  <p>이메일 주소</p>
                </div>
                <div class="input_area">
                  <input
                    id="find_all_email"
                    v-model="userEmail"
                    type="text"
                    class="input"
                    name="user_info"
                    placeholder="가입한 이메일 주소를 입력해주세요."
                    @input="checkEmail"
                  />
                  <div
                    id="code_send_email"
                    class="btn btn_basic"
                    :class="{
                      disabled: userEmail.indexOf('@') && !isEmailButtonEnabled,
                    }"
                    @click="sendOtp('email')"
                  >
                    인증번호 받기
                  </div>
                </div>
              </div>
              <div class="input_group">
                <div class="title_area">
                  <p>인증코드 확인</p>
                </div>

                <div class="input_area">
                  <input
                    id="user_code_email"
                    v-model="userCode"
                    type="text"
                    class="input width_full"
                    name=""
                    placeholder="인증코드를 입력해 주세요."
                    maxlength="6"
                  />
                  <span id="code_count_email">--:--</span>
                </div>

                <div class="resend"></div>
              </div>

              <div class="btn_area">
                <input
                  type="button"
                  class="btn_orange"
                  value="확인"
                  @click="sendData()"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="Modals">
    <ModalAlert
      :alertMsg="errMsg"
      :is-open="errStatus"
      :fail-check="approachFail"
      @update:is-open="updateStatus"
    ></ModalAlert>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { sendOtpNumber, letFindIDAll } from '../api/find'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'FindIDAllViews',
  components: {
    ModalAlert,
  },
  setup() {
    const router = useRouter()
    const sendWay = ref('sms')

    const errMsg = ref('')
    const errStatus = ref(false)
    const approachFail = ref('')
    const getFirstLS = ref(localStorage.getItem('firstStap'))

    const btnOn = ref(false)

    const userPhone = ref('')
    // 포맷된 전화번호
    const hypenPhoneNum = ref('')
    const userEmail = ref('')
    const userCode = ref('')

    const isPhoneButtonEnabled = computed(() => userPhone.value.length === 11)
    const isEmailButtonEnabled = computed(() => userEmail.value)
    // 정규식 패턴 정의
    // const phoneRegex = /^010\d{8}$/ // 010으로 시작하는 11자리 번호
    // const phoneRegex = /^010-\d{4}-\d{4}$/
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    // const plainPhoneNumber = ref('')

    const toggleType = (type) => {
      if (type === 'sms') {
        sendWay.value = 'sms'
        userEmail.value = ''
        userCode.value = ''
      } else if (type === 'email') {
        sendWay.value = 'email'
        userPhone.value = ''
        hypenPhoneNum.value = ''
        userCode.value = ''
      }
    }

    const sendOtp = async (type) => {
      const getUserName = localStorage.getItem('userName')
      const sendOTP = ref('')
      if (userPhone.value && (type === 'sms' || type === '')) {
        // 휴대폰 번호 유효성 검사
        // if (!phoneRegex.test(hypenPhoneNum.value)) {
        //   errMsg.value = '유효한 휴대폰 번호를 입력해주세요.'
        //   errStatus.value = true
        //   return
        // }
        sendOTP.value = await sendOtpNumber(
          sendWay.value,
          getUserName,
          userPhone.value
        )
      } else if (userEmail.value && type === 'email') {
        // 이메일 유효성 검사
        if (!emailRegex.test(userEmail.value)) {
          errMsg.value = '유효한 이메일 주소를 입력해주세요.'
          errStatus.value = true
          return
        }
        sendOTP.value = await sendOtpNumber(
          sendWay.value,
          getUserName,
          userEmail.value
        )
      }
      if (sendOTP.value.code === 'MB21000200') {
        errStatus.value = true
        errMsg.value = '인증번호가 전송되었습니다.'
        btnOn.value = true
      } else {
        errStatus.value = true
        errMsg.value = '오류가 발생했습니다. 다시 시도해주세요'
      }
    }

    const updateStatus = () => {
      errStatus.value = false
    }

    const checkHP = (e) => {
      // 숫자만 남기고 하이픈을 넣는 로직
      const input = e.target.value.replace(/\D/g, '')
      if (input.length <= 3) {
        hypenPhoneNum.value = input
      } else if (input.length <= 7) {
        hypenPhoneNum.value = `${input.slice(0, 3)}-${input.slice(3)}`
      } else {
        hypenPhoneNum.value = `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7)}`
      }
      // 하이픈 제거한 값을 userPhone에 저장
      userPhone.value = input
    }

    const checkEmail = () => {
      if (userEmail.value.indexOf('@') !== -1 && btnOn) {
        document.getElementById('code_send_email').classList.remove('disabled')
      } else {
        document.getElementById('code_send_email').classList.add('disabled')
      }
    }
    // const sendData = async () => {
    //   try {
    //     const findWholeId = await letFindIDAll(
    //       sendWay.value,
    //       userPhone.value,
    //       userEmail.value,
    //       otpCodeHP.value,
    //       otpCodeEmail.value
    //     )
    //     if (findWholeId.code === 'MB21700200') {
    //       router.push({ name: 'FindIDNoneMaskingView' })
    //     }
    //   } catch (err) {
    //     // console.log(err);
    //   }
    // }

    // eslint-disable-next-line consistent-return
    const sendData = async () => {
      try {
        const userName = ref(localStorage.getItem('userName'))
        const findWholeId = await letFindIDAll(
          userName.value,
          userPhone.value,
          userEmail.value,
          userCode.value
        )
        if (findWholeId.code === 'MB21100200') {
          router.push({ name: 'FindIDNoneMaskingView' })
        } else if (findWholeId.status_code === 400) {
          errMsg.value =
            '인증번호가 입력되지 않았습니다.<br>발송된 인증번호를 입력해 주세요.'
          errStatus.value = true
          // eslint-disable-next-line consistent-return
          return false
        } else if (findWholeId.status_code === 404) {
          errMsg.value =
            '잘못된 인증번호입니다.<br>발송된 인증번호를 다시 확인해 주세요.'
          errStatus.value = true
        }
      } catch (err) {
        // console.log(err);
      }
    }

    onMounted(() => {
      if (!getFirstLS.value) {
        errMsg.value = '잘못된 접근입니다.'
        errStatus.value = true
        approachFail.value = 'ApproachFail'
      }
    })
    return {
      errMsg,
      errStatus,
      btnOn,
      userPhone,
      hypenPhoneNum,
      userEmail,
      userCode,
      // otpCodeHP,
      // otpCodeEmail,
      approachFail,

      toggleType,
      sendOtp,
      updateStatus,
      checkHP,
      checkEmail,
      sendData,
      // plainPhoneNumber,

      isPhoneButtonEnabled,
      isEmailButtonEnabled,
    }
  },
}
</script>
